module.exports = __webpack_public_path__ + "logistic.9f468c9f6f8529f9a855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistic.jpg
// module id = 1207
// module chunks = 2